exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".error-msg[data-v-71278ae6] {\n  display: flex;\n  margin-bottom: 8px;\n}\n.error-msg .error-icn[data-v-71278ae6] {\n  width: 20px;\n  height: 20px;\n  background: var(--danger);\n  color: #fff;\n  display: block;\n  border-radius: 3px;\n  text-align: center;\n  line-height: 20px;\n  flex: none;\n  margin-right: 15px;\n}\n.error-msg .error-txt[data-v-71278ae6] {\n  color: var(--danger);\n}\n.fade-enter-active[data-v-71278ae6],\n.fade-leave-active[data-v-71278ae6] {\n  transition: opacity 0.3s;\n}\n.fade-enter[data-v-71278ae6],\n.fade-leave-to[data-v-71278ae6] {\n  opacity: 0;\n}", ""]);

// exports
